module.exports = __webpack_public_path__ + "static/p2-542c32f7ea19ce5406d52305fd5355b0.svg";